import React, { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

export const VercelAnalyticsManager: React.FC = () => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      try {
        const consent = localStorage.getItem("skjeta_cookie_consent");
        if (consent) {
          const parsed = JSON.parse(consent);
          setShouldRender(!!parsed.analytics);
        } else {
          setShouldRender(false);
        }
      } catch (e) {
        setShouldRender(false);
      }
    };

    checkConsent();

    // Check again every second in case they just accepted it
    const interval = setInterval(checkConsent, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!shouldRender) return null;

  return <>
      <Analytics />
      <SpeedInsights />
    </>;
};
